import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router';
import { LottiePlayer } from '@repo/design-system-kit';
import genericError from '@repo/visual-assets/animations/generic_error.lottie';
import { Link } from '@repo/poly-hooks/components';
import { QontoHeader } from 'receivable-invoices-js/react/components/shared/qonto-header';
import { useFetchClientPortalSettings } from 'receivable-invoices-js/react/api/queries/fetch-client-portal-settings';
import styles from './layout.module.css';

export function QuotesSigningSignatureFailedRoute(): ReactNode {
  const params = useParams<{ id: string; clientId: string }>();
  const clientId = params.clientId || '';
  const quoteId = params.id || '';

  const { data: clientPortalSettings } = useFetchClientPortalSettings(
    { clientId },
    {},
    { enabled: Boolean(clientId) }
  );
  const isClientPortalEnabled = clientPortalSettings?.clientPortalEnabled ?? false;
  return (
    <>
      <header className={styles.qontoHeader} data-test-qonto-header>
        <QontoHeader />
        {isClientPortalEnabled ? (
          <a
            className="btn"
            data-test-client-portal-cta
            href={`/clients/${clientId}`}
            type="button"
          >
            <FormattedMessage id="quote.preview.cta.portal" />
          </a>
        ) : null}
      </header>
      <main className={styles.container}>
        <LottiePlayer
          autoplay
          className={`mb-32 ${styles.image}`}
          data-test-signature-error-illustration=""
          path={genericError}
        />
        <div className={`mb-32 ${styles.textContainer}`}>
          <h1 className="title-1 mb-16" data-test-signature-error-title>
            <FormattedMessage id="receivable-invoices.quote-sending.e-signature.error.title" />
          </h1>
          <p className="body-1" data-test-signature-error-subtitle>
            <FormattedMessage id="receivable-invoices.quote-sending.e-signature.error.body" />
          </p>
        </div>
        <Link
          className="btn btn--primary"
          data-test-signature-retry
          replace
          to={`/quotes/${quoteId}/signing/${clientId}`}
        >
          <FormattedMessage id="btn.retry" />
        </Link>
      </main>
    </>
  );
}
